var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#261C37",
    d: "M13.908 18.188a2.202 2.202 0 0 1-3.815 0l-4.658-8.07a2.177 2.177 0 0 1 1.907-3.261h9.317c1.684 0 2.743 1.809 1.907 3.257l-4.658 8.079zm-1.072-9.514a.922.922 0 0 0-1.671 0l-2.066 3.982a.94.94 0 0 0 0 .831l2.066 3.977a.92.92 0 0 0 1.671 0l2.066-3.977a.94.94 0 0 0 0-.831l-2.066-3.978z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenet);
export default __webpack_public_path__ + "static/media/tenet.f7eccfeaa879158089c2cddc35aa2050.svg";
export { ForwardRef as ReactComponent };